module.exports = __webpack_public_path__ + "static/jumpPreview.9642e876.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/jumpPreview.png
// module id = 466
// module chunks = 44780966157200